import { render, staticRenderFns } from "./account-email-verify.vue?vue&type=template&id=681cc79c&"
import script from "./account-email-verify.vue?vue&type=script&lang=js&"
export * from "./account-email-verify.vue?vue&type=script&lang=js&"
import style0 from "./account-email-verify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports